import { __spreadArrays } from "tslib";
import clone from "lodash-es/clone";
import isEqual from "lodash-es/isEqual";
import isObject from "lodash-es/isObject";
import setWith from "lodash-es/setWith";
import transform from "lodash-es/transform";
/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
export var is = function (x, y) {
    // SameValue algorithm
    if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        // Added the nonzero y check to make Flow happy, but it is redundant
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
};
// export const test = () => {
//     return RulesEngine;
// };
/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
export var shallowEqual = function (objA, objB) {
    if (is(objA, objB)) {
        return true;
    }
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Test for A's keys different from B.
    for (var i = 0; i < keysA.length; i++) {
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
};
/**
 * difference
 * Deep diff
 * @param rawObject
 * @param rawBase
 */
export var difference = function (rawObject, rawBase) {
    function changes(object, base, pathSegments) {
        if (pathSegments === void 0) { pathSegments = []; }
        return transform(object, function (result, value, key) {
            if (!isEqual(value, base[key])) {
                result[key] = isObject(value) && isObject(base[key]) ? changes(value, base[key], __spreadArrays(pathSegments, [key])) : value;
            }
        });
    }
    return changes(rawObject, rawBase);
};
/**
 * immutableSet
 * Will create new object references for every nested level for the property that is being set.
 * i.e. you set property "widget.component.address.street" in obj with value "my street". With Lodash set, the value is being updated but in
 * some specific cases (i.e. setting nested properties dynamically in the Redux reducers), the child objects should be recreated as well. Otherwise
 * consumers of these properties will not detect a change at all the different levels.
 * A deep merge can do the job, but will be less performing since the whole object has to be recreated.
 * This function will only recreate the path to the applicable property.
 * @param obj
 * @param key
 * @param value
 */
export var immutableSet = function (obj, key, value, customizer) {
    return setWith(clone(obj), key, value, function (nsValue, subKey, nsObject) { return (customizer ? clone(customizer(nsValue)) : clone(nsValue)); });
};
/**
 * pick
 * Simple pick implementation which is usefull when you don't need the complete
 * lodash implementation and save a few kb's
 * @param obj
 */
export var pick = function (obj, keys) {
    var keysArr = typeof keys === "string" ? [keys] : keys;
    return keysArr.reduce(function (acc, key) {
        acc[key] = obj.hasOwnProperty(key) ? obj[key] : undefined;
        return acc;
    }, {});
};
/**
 * Gets the value at path of object. If the resolved value is undefined, the defaultValue is returned in its place.
 *
 * @param obj
 * @param path
 * @param defaultValue
 * @returns
 */
export var get = function (obj, path, defaultValue) {
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    var keys = path.split('.');
    for (var i = 0, n = keys.length; i < n; ++i) {
        var key = keys[i];
        if (key in obj) {
            obj = obj[key];
        }
        else {
            return defaultValue;
        }
    }
    return obj;
};
//# sourceMappingURL=Obj.js.map